import backgroundLuckyWheelImage from '@/assets/images/BG_GiroPremiado_MobH2.png';
import backgroundLuckyWheelDeskImage from '@/assets/images/BG_GiroPremiadoH2.png';
import H2PremiosWheelLogo from '@/assets/images/h2bWheel.png';
import H2PremiosLogo from '@/assets/images/h2premios.png';
import LotepImage from '@/assets/images/lotepLogoWhite.png';
import { Colors } from '@/brands/h2b/colors';
import { buildHomeDescription, buildHomeTitle, buildPageSeo } from '@/brands/seo';
import { type BrandPageSeo, type WhitelabelConfig } from '@/brands/types';
import { LuckySequencyType } from '@/types/enums/HighlightedRaffle';

import type { Metadata } from 'next';

const H2B_DOMAIN = 'https://h2premios.com.br/';
const H2B_DISPLAY_NAME = 'H2 Prêmios';

export const h2bPageSeo: BrandPageSeo = buildPageSeo(H2B_DISPLAY_NAME);

export const h2bMetaData: Metadata = {
  title: buildHomeTitle(H2B_DISPLAY_NAME),
  description: buildHomeDescription(H2B_DISPLAY_NAME),
  metadataBase: new URL(H2B_DOMAIN),
  openGraph: {
    title: 'H2 Prêmios',
    description:
      'A H2 Prêmios é uma empresa de distribuição de bilhetes lotéricos que oferece aos participantes a oportunidade de concorrer a diversos prêmios. Nosso objetivo é ...',
    url: H2B_DOMAIN,
    siteName: 'H2 Prêmios',
    images: [
      {
        url: 'https://h2b-prod-public-bucket.s3.us-east-1.amazonaws.com/Thumb+link+(1).png',
        width: 1200,
        height: 630,
        alt: 'H2 Prêmios',
      },
    ],
    locale: 'pt_BR',
    type: 'website',
  },
  icons: {
    icon: '/favicon/Fav-h2premio-32x32.png',
    apple: '/favicon/Fav-h2premio-32x32.png',
  },
  robots: {
    index: true,
    follow: true,
    nocache: false,
  },
  twitter: {
    card: 'summary_large_image',
    title: 'H2 Prêmios',
    description: 'Chance real de ganhar, na palma da sua mão!',
    images: [
      'https://h2b-prod-public-bucket.s3.us-east-1.amazonaws.com/Thumb+link+(1).png',
    ],
  },
};

// TODO: add checkoutCheckboxes in WhitelabelConfig
export const h2bConfig: WhitelabelConfig = {
  name: 'h2b',
  displayName: 'H2 Prêmios',
  latestWinnersVideos: [],
  skipAddressStep: true,
  availableGames: [LuckySequencyType.LUCKY_WHEEL],
  assets: {
    logo: H2PremiosLogo.src,
    logoHeader: H2PremiosLogo.src,
    logoMenu: H2PremiosLogo.src,
    logoFooter: H2PremiosLogo.src,
    logoWheel: H2PremiosWheelLogo.src,
    luckyWheelBackground: backgroundLuckyWheelImage.src,
    luckyWheelBackgroundDesktop: backgroundLuckyWheelDeskImage.src,
  },
  capitalizer: {
    link: 'https://lotep.pb.gov.br/',
    displayName: 'LOTEP - Loteria do Estado da Paraíba',
    logoFooter: LotepImage.src,
  },
  colors: Colors,
  meta: {
    description: 'H2 Prêmios',
    baseUrl: 'https://h2premios.com.br/',
    ogImage: '/images/H2bLogo.png',
    favicon: '/favicon/Fav-h2premio-32x32.png',
    appleIcon: '/favicon/Fav-h2premio-32x32.png',
  },
  checkoutCheckboxes: {
    marketingOptIn: {
      visible: true,
      required: false,
      label: 'Aceito receber comunicações de marketing e ofertas',
      errorMessage: 'Você deve aceitar receber comunicações de marketing',
    },
    termsOfService: {
      visible: true,
      required: true,
      label: 'Concordo com os termos',
      errorMessage: 'Você deve concordar com os Termos de Uso',
      prefixText: 'Concordo com a',
      brandText: 'do H2 Prêmios',
      links: [
        { text: 'Política de Privacidade', href: '/politica-de-privacidade' },
        { text: 'Termos de Uso', href: '/termos-de-uso' },
      ],
    },
  },
};
